import { render, staticRenderFns } from "./Premium.vue?vue&type=template&id=77ecd7ee&"
import script from "./Premium.vue?vue&type=script&lang=js&"
export * from "./Premium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports